import { CURRENT_SCHEMA_VERSION } from 'lib/constants';

export const appUpdateRequired = (project) => {
  return _.get(project, 'data.schema') > CURRENT_SCHEMA_VERSION;
}
